import { Fragment } from "react";
import { getLabel } from "../../../../../../../../hooks/use-labels";
import { getStyle } from "../../../../../../../../hooks/use-styles";
import { Dropdown } from "antd";
import { getUnsupportedProducts } from "../type-content-utils";

const TypeDescriptionView = (props) => {
  const { description, image, valueText, unsupportedProducts } = props;
  const items = getUnsupportedProducts(unsupportedProducts);
  return (
    <Fragment>
      <div>{description}</div>
      <div className="flex align-center description-view-icon-container">
        <img src={image} alt="typeIcon" />
        {valueText}
      </div>

      {unsupportedProducts.length > 0 && (
        <div className="mt-unsupported-products flex align-center justify-between mt-20">
          <div
            className="font-12-normal-400-lh-14 weight-500"
            style={{ color: getStyle("black") }}
          >
            {getLabel("unsupportedProductsMessage")}
          </div>

          <Dropdown menu={{ items }} trigger={"click"} placement="bottom">
            <img
              src="/assets/icons/shopping-cart/info-circle.svg"
              alt="infoCircle"
              className="pointer"
            />
          </Dropdown>
        </div>
      )}
    </Fragment>
  );
};

export default TypeDescriptionView;
